import { Box, Stack, Typography, Button } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { RouteObject, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { authServiceAxiosClient } from '@/lib/axios';

const ReturnPageContent = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Checking payment status');
  const [dots, setDots] = useState('.');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (message === 'Checking payment status') {
      interval = setInterval(() => {
        setDots((prev) => (prev.length === 3 ? '.' : prev + '.'));
      }, 500);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [message]);

  useEffect(() => {
    if (!sessionId) {
      setMessage('Missing session ID.');
      return;
    }

    authServiceAxiosClient
      .get(`/subscription/checkout-session/${sessionId}`)
      .then((res) => res.data)
      .then((data: { payment_status?: string }) => {
        if (data?.payment_status === 'paid') {
          setMessage(
            'Thank you for your payment! You will receive a confirmation email shortly to verify your account.',
          );
        } else {
          setMessage(`Payment status: ${data?.payment_status ?? 'unknown'}`);
        }
      })
      .catch(() => {
        setMessage('An error occurred while verifying payment.');
      });
  }, [sessionId]);

  return (
    <Box
      width="100%"
      height="100vh"
      display="grid"
      color="GrayText"
      sx={{ placeItems: 'center' }}
    >
      <Stack alignItems="center" spacing={4}>
        <ErrorIcon color="error" sx={{ height: 120, width: 120 }} />
        <Typography
          fontSize={28}
          fontWeight={500}
          textAlign="center"
          sx={{ width: '70vw', maxWidth: '70vw', wordBreak: 'break-word' }}
        >
          {message === 'Checking payment status'
            ? `${message}${dots}`
            : message}
        </Typography>
        <style>{`
          .MuiTypography-root a {
            color: inherit;
            text-decoration: underline;
          }
        `}</style>
        {message !== 'Checking payment status' && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              window.location.href = '/login';
            }}
          >
            Go to Home
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export const subscriptionReturnRoute: RouteObject = {
  path: '/return',
  element: <ReturnPageContent />,
};
